export class LoyaltyData {
  public id                    : string;
  public p4mId                 : string;
  public statusCode            : string;
  public totalPoints           : number;
  public totalPointsCollected  : number;
  public totalPointsUsed       : number;
  public cards                 : Card[];
  public coupons               : Coupon[];
  public rewards               : Reward[];

  constructor (data:any) {
    this.id                   = data.id;
    this.p4mId                = data.p4mId;
    this.statusCode           = data.statusCode;
    this.totalPoints          = data.totalPoints;
    this.totalPointsCollected = data.totalPointsCollected;
    this.totalPointsUsed      = data.totalPointsUsed;

    this.cards = [];
    if (data.cards && data.cards.length > 0) {
      this.cards = data.cards.map(it => new Card(it));
    }

    this.coupons = [];
    if (data.coupons && data.coupons.length > 0) {
      this.coupons = data.coupons.map(it => new Coupon(it));
    }

    this.rewards = [];
    if (data.rewards && data.rewards.length > 0) {
      this.rewards = data.rewards.map(it => new Reward(it));
    }
  }
}

export class Card {
  public number  : string;
  public qrCode  : string;
  public type    : string;
  public active  : boolean;
  public primary : boolean;

  constructor (data:any) {
    this.number      = data.number;
    this.qrCode      = data.qrCode;
    this.type        = data.type;
    this.active      = data.active;
    this.primary     = data.primary;
  }
}

export class Coupon {
  public id                   : string;
  public createDate           : Date;
  public externalCode         : string;
  public isAllDay             : boolean;
  public isUnlimited          : boolean;
  public lastRedeemDate       : Date;
  public redeemDependencyCode : string;
  public validFrom            : Date;
  public validTo              : Date;
  public images               : Image[];
  public translations         : any;

  constructor (data:any) {
    this.id                       = data.id;
    this.createDate               = new Date(data.createDate);
    this.externalCode             = data.externalCode;
    this.isAllDay                 = data.isAllDay;
    this.isUnlimited              = data.isUnlimited;
    this.lastRedeemDate           = data.lastRedeemDate ? new Date(data.lastRedeemDate) : null;
    this.redeemDependencyCode     = data.redeemDependencyCode;
    this.validFrom                = data.validFrom ? new Date(data.validFrom) : null;
    this.validTo                  = data.validTo ? new Date(data.validTo) : null;

    this.images = [];
    if (data.images && data.images.length > 0) {
      this.images = data.images.map(it => new Image(it));
    }

    this.translations = {};
    if (data.translations) {
      for (let k in data.translations) {
        if (data.translations.hasOwnProperty(k)) {
          const val = data.translations[k];
          this.translations[k] = new Translation(val);
        }
      }
    }
  }
}

export class Reward {
  public id                   : string;
  public createDate           : Date;
  public externalCode         : string;
  public decreasePoints       : boolean;
  public isAllDay             : boolean;
  public isUnlimited          : boolean;
  public lastRedeemDate       : Date;
  public points               : number;
  public pointsNeeded         : number;
  public redeemDependencyCode : string;
  public validFrom            : Date;
  public validTo              : Date;
  public images               : Image[];
  public translations         : any;

  constructor (data:any) {
    this.id                       = data.id;
    this.createDate               = new Date(data.createDate);
    this.externalCode             = data.externalCode;
    this.decreasePoints           = data.decreasePoints;
    this.isAllDay                 = data.isAllDay;
    this.isUnlimited              = data.isUnlimited;
    this.lastRedeemDate           = data.lastRedeemDate ? new Date(data.lastRedeemDate) : null;
    this.points                   = data.points;
    this.pointsNeeded             = data.pointsNeeded;
    this.redeemDependencyCode     = data.redeemDependencyCode;
    this.validFrom                = data.validFrom ? new Date(data.validFrom) : null;
    this.validTo                  = data.validTo ? new Date(data.validTo) : null;

    this.images = [];
    if (data.images && data.images.length > 0) {
      this.images = data.images.map(it => new Image(it));
    }

    this.translations = {};
    if (data.translations) {
      for (let k in data.translations) {
        if (data.translations.hasOwnProperty(k)) {
          const val = data.translations[k];
          this.translations[k] = new Translation(val);
        }
      }
    }
  }
}

export class Image {
  public name            : string;
  public url             : string;
  public destinationUrl  : string;
  public path            : string;
  public tags            : string[];

  constructor (data:any) {
    this.name           = data.name;
    this.url            = data.url;
    this.destinationUrl = data.destinationUrl;
    this.path           = data.path;
    this.tags           = data.tags;
  }
}

export class Translation {
  public title    : string;
  public subtitle : string;
  public body     : string;

  constructor (data:any) {
    this.title     = data.title;
    this.subtitle  = data.subtitle;
    this.body      = data.body;
  }
}

export class LoyaltyHistory {
  public p4mId                 : string;
  public transactions          : Transaction[];

  constructor (data:any) {
    this.p4mId                = data.p4mId;

    this.transactions = [];
    if (data.transactions && data.transactions.length > 0) {
      this.transactions = data.transactions.map(it => new Transaction(it));
    }
  }
}

export class Transaction {
  public code            : string;
  public date            : Date;
  public points          : number;
  public storeId         : string;
  public storeName       : string;
  public typeCode        : string;
  public subTypeCode     : string;

  constructor (data:any) {
    this.code         = data.code;
    this.date         = new Date(data.date);
    this.points       = data.points;
    this.storeId      = data.storeId;
    this.storeName    = data.storeName;
    this.typeCode     = data.typeCode;
    this.subTypeCode  = data.subTypeCode;
  }
}

export class ShareId {
  public p4mId   : string;
  public shareId : string;

  constructor (data:any) {
    this.p4mId    = data.p4mId;
    this.shareId  = data.shareId;
  }
}

export class QrCode {
  public imageData   : string;
  public contentType : string;
  public cardNumber  : string;

  constructor (data:any) {
    this.imageData    = data.imageData;
    this.contentType  = data.contentType;
    this.cardNumber   = data.cardNumber;
  }
}

export class AddReceiptResponse {
  public p4mId   : string;
  public pointsForRevenue : number;
  public totalPoints : number;
  public totalPointsCollected : number;
  public totalPointsUsed : number;
  public receiptId  : string;
  public receiptDate  : string;

  constructor (data:any) {
    this.p4mId    = data.p4mId;
    this.pointsForRevenue  = data.pointsForRevenue;
    this.totalPoints  = data.totalPoints;
    this.totalPointsCollected  = data.totalPointsCollected;
    this.totalPointsUsed  = data.totalPointsUsed;
    this.receiptId   = data.receiptId;
    this.receiptDate   = data.receiptDate;
  }
}

export class PartnerPromotion {
  public code : string;

  constructor (data:any) {
    this.code = data.code;
  }
}